/**
 * @generated SignedSource<<67b9c411c5c3c36bdc5489ac0b84e077>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsModal_viewer$data = {
  readonly activeDelegation: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer">;
  readonly " $fragmentType": "SettingsModal_viewer";
};
export type SettingsModal_viewer$key = {
  readonly " $data"?: SettingsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegation",
      "kind": "LinkedField",
      "name": "activeDelegation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingIdentityFeaturesPaywall_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ba7fdc0be0f5a3c41db21ff1cdbd71c5";

export default node;
